<template>
    <!-- 私人银行家学习路线 -->
    <div class="Lombard">
        <div class="conter">
            <div class="banner">
                <!-- 状态1 -->
                <div class="state_1" style="" v-if="studyInfo.progress==0" @click="startStudy(0)">开始学习</div>
                <!-- 状态2 -->
                <div class="state_2" v-if="studyInfo.progress == 1">
                    <div id="main1" style="width: 1.38rem;height:1.28rem; position: absolute; left: 3%; top: 10%;" ref="main_t"></div>
                    <span class="easc">{{this.e}}%</span>
                    <span class="easc_1">完成度</span>
                    <div class="tet">
                        <p>上次学到</p>
                        <p class="course-name">{{studyInfo.goodsName}}</p>
                    </div>
                    <a class="btn" style="line-height: 0.52rem;padding: 0;" @click="startStudy(1)">开始学习</a>
                </div>
                <!-- 状态3 -->
                <div class="state_3" v-if="studyInfo.progress >= 2">
                    <div id="main1" style="width: 1.38rem;height:1.28rem; position: absolute; left: 3%; top: 10%;" ref="main_t"></div>
                    <span class="easc">{{this.e}}%</span>
                    <span class="easc_1">完成度</span>
                    <div class="tet">
                        <p>您已完成{{curLevelName}}课程</p>
                        <p><span class="tet_1">{{nextLevelName}}</span>课程已解锁</p>
                    </div>
                    <a class="btn" style="line-height: 0.52rem;padding: 0;" v-if="studyInfo.progress == 2" @click="toTest()">进阶考试</a>
                    <!--
                    <a class="btn" style="line-height: 0.52rem;padding: 0;" v-else @click="nextStudy()">开始学习</a>
                    -->
                </div>
            </div>
            <div class="cen" style="margin-top: .8rem;">
                <div class="flow">
                    <div class="content">

                        <img src="//images.jinku.com/newjk/org/images/expert_images/expert_lock_03.png" alt="" style="width: 132px;height: 128px;position: absolute;left: 295px;top: -38px;"
                            @click="toAppUrl('/Elite')">

                        <div v-for="(structure, i) in structureArr" :class="'index_' + (i + 1)">
                            <template v-for="(node, subIdx) in structure">
                                <a href="#" :class="node.cls" v-if="node.son && node.son.length">{{node.name}}</a>
                                <a href="#" :class="node.cls" @click="showGoods($event,node.id, 1)" v-else>{{node.name}}</a>
                            </template>
                        </div>

                        <!--共性节点-->
                        <div v-for="(structure, i) in commonNodes" :class="'common_' + (i + 1)">
                            <template v-for="(node, subIdx) in structure">
                                <a href="#" :class="node.cls" v-if="node.son && node.son.length">{{node.name}}</a>
                                <a href="#" :class="node.cls" @click="showGoods($event,node.id, 1)" v-else>{{node.name}}</a>
                            </template>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <p class="goBack" @click="goBack(levelNum)">点击返回</p>
        <popup></popup>
    </div>
</template>

<script>
    import http from "../../lib/http";

    const echarts = require('echarts');
    import bus from '../../bus.js'
    import Popup from '../Popup.vue'

    export default {
        name: 'Lombard',
        data() {
            return {
                e: 0,
                studyInfo: {
                    progress: 0, // 0=未开始；1=学习中；2=学习完成(未通过考试)；3=学习完成（已通过考试）
                    goodsId: 0,
                    goodsName: ''
                },
                showCFDR: false, // 显示财富达人
                showCFJY: false, // 显示财富精英
                showSRYHJ: false, // 显示私人银行家
                structureArr: [],
                commonNodes:[],
                levelNum: 0,
                userLeafLevel: 0,
                firstGoodsId: 0,
                allLevel: {
                    '1': '财富新人',
                    '2': '财富达人',
                    '3': '财富精英',
                    '4': '私人银行家'
                },
                allLevelUrl: {
                    '1': '/Newble',
                    '2': '/Expert',
                    '3': '/Elite',
                    '4': '/Lombard'
                }
            }
        },
        computed: {
            curLevelName: function() {
                return this.allLevel[this.levelNum] || '';
            },
            nextLevelName: function() {
                return this.allLevel[this.levelNum + 1] || '';
            }
        },
        components: {
            Popup
        },
        methods: {
            myMain() {
                let myMain_t = echarts.init(document.getElementById('main1'));
                myMain_t.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: "{d}%",
                        show: false
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'center',
                        show: false
                    },
                    color: ['#068CFD', 'rgba(0,0,0,.1)'], //颜色
                    series: {
                        name: '',
                        type: 'pie',
                        radius: ['65%', '85%'],
                        avoidLabelOverlap: true,
                        hoverAnimation: false,
                        label: {
                            normal: {
                                show: true,
                                position: 'left'
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [{
                                value: this.e,
                                name: ''
                            },
                            {
                                value: 100 - this.e,
                                name: ''
                            }
                        ]
                    }

                })
            },
            tj_expert() {
                this.$router.push('/Expert');
            },
            tz_elite() {
                this.$router.push('/Elite');
            },
            goBack(levelNum){
                this.$router.push({
                  name:"breviary",
                  path: "breviary",
        　　　　　　query:{
        　　　　　　　　levelNum:levelNum
        　　　　　　}
                }).catch(function(err){
        
                });
            },
            toAppUrl(url) {
                this.$router.push(url);
            },
            toNexLevel(url) { // 跳转至下一个级别
                if (this.studyInfo.progress > 2) {
                    this.toAppUrl(url);
                } else {
                    this.toTest()
                }
            },
            conceal() {
                if (this.e == 100) {
                    this.unconceal = false;
                    this.esconceal = true;
                }
            },
            nodeInfo(fn) { // 节点信息
                if (!this.levelNum) return;
                var that = this;
                http({
                    method: 'POST',
                    url: '/org/structure/get-structure-info',
                    data: "level_num=" + that.levelNum
                }).then(function(data) {
                    if (!data || !data.data || !data.data.list) {
                        return;
                    }

                    var allData = data.data.list;
                    var curNode = (allData instanceof Array) ? allData[0] : allData;

                    if (curNode) {
                        var cfxy = [],
                            commonNodes = [],
                            firstLeafNodeId = 0;
                        var redDot = ',' + (data.data.redDot || []).join(',') + ',';
                        var index = 1;
                        for (var i in curNode.son) {
                            cfxy.push(getAllChild(curNode.son[i], 'item_' + index++, 1))
                        }

                        // 共性节点
                        index = 1;
                        for (var i in curNode.common_node) {
                            commonNodes.push(getAllChild(curNode.common_node[i], 'simils' + index++, 1, 1));
                        }

                        that.commonNodes = commonNodes;

                        function getAllChild(nodes, parentClass, level, isCommonNode) {
                            if (!nodes) return null;
                            // true = 红点节点
                            var isNewNode = redDot.indexOf(',' + nodes.id + ',') > -1;
                            if (isCommonNode) {
                                if (level == 2) {
                                    nodes.cls = 'simil ' + parentClass
                                } else if (level == 3) {
                                    nodes.cls = 'itemB ' + parentClass
                                } else {
                                    nodes.cls = parentClass;
                                }
                            } else {
                                if (level == 2) {
                                    nodes.cls = 'item ' + parentClass
                                } else if (level == 3) {
                                    nodes.cls = 'item1 ' + parentClass
                                } else {
                                    nodes.cls = parentClass;
                                }
                            }
                            if(isNewNode){
                                nodes.cls += ' leaf-node';
                            }

                            nodes.level_num = level;

                            var rst = [],
                                childs = nodes.son;
                            rst.push(nodes);
                            if (childs && childs.length) {
                                var index = 1;
                                for (var i in childs) {
                                    rst = [].concat.apply(rst, getAllChild(childs[i], parentClass + '_' + index++,
                                        level + 1,isCommonNode));
                                }
                            } else {
                                // 叶子节点
                                if (!firstLeafNodeId) {
                                    firstLeafNodeId = nodes.id;
                                }
                            }
                            return rst;
                        }

                        that.structureArr = cfxy;

                        setTimeout(function() {
                            that.showGoods(firstLeafNodeId, 0);
                        })
                    }

                });
            },

            userInfo() {
                // 用户信息
                var that = this;
                http({
                    method: 'POST',
                    url: '/org/user/get'
                }).then((data) => {
                    if (!data) return;
                    data = data.data;
                    if (!data) return;
                    that.userLevel = data.org_user_level;
                }).then(function() {
                    that.rate()
                });

            },
            rate() { // 进度
                // 获取用户当前级别的学习进度
                var that = this;
                http({
                    method: 'POST',
                    url: '/org/user/current-study',
                    data: "level_num=" + that.levelNum
                }).then(function(data) {

                    if (that.userLevel >= 2) {
                        that.showCFDR = true;
                    }
                    if (that.userLevel >= 3) {
                        that.showCFJY = true;
                    }
                    if (that.userLevel >= 4) {
                        that.showSRYHJ = true;
                    }

                    if (!data) return;
                    data = data.data;
                    if (!data) return;
                    that.e = isNaN(data.speed) ? 0 : parseInt(data.speed * 100)
                    // 0=未开始；1=学习中；2=学习完成(未通过考试)；3=学习完成（已通过考试）
                    if (that.e <= 0) { // 未开始
                        that.studyInfo.progress = 0;
                    } else if (that.e < 100) { // 学习中
                        that.studyInfo.progress = 1;
                    } else if (that.userLevel > that.levelNum) { // 学习完成，通过考试
                        that.studyInfo.progress = 3;
                    } else { // 学习完成，未通过考试
                        that.studyInfo.progress = 2;
                    }

                    if (that.studyInfo.progress >= 1) {
                        setTimeout(function() {
                            that.myMain();
                        }, 300)
                    }

                    if (that.studyInfo.progress > 1) { // 学习完成
                        that.showCFDR = true;
                    }

                    that.studyInfo.goodsId = data.goods_id;
                    that.studyInfo.goodsName = data.goods_name;
                });
            },
            toTest() { // 进阶考试
                let that = this;
                http({
                    method: 'POST',
                    url: '/org/exam/create-paper',
                    data: ''
                }).then(function(data) {
                    // 去考试
                    if (!data) return;
                    if (data.code != 0) {
                        alert(data.mess || '数据异常');
                        return;
                    }
                    data = data.data;
                    if (!data) return;
                    if (data.paper_id)
                        that.$router.push({
                            path: '/do-paper?paper_id=' + data.paper_id
                        });
                });
            },
            startStudy(firstStudy /*是否首次学习*/ ) { // 开始学习
                var goodsId = firstStudy ? (this.firstGoodsId || this.studyInfo.goodsId) : this.studyInfo.goodsId;
                if (!goodsId) return;
                var a = document.createElement("a");
                a.setAttribute("href", 'https://m.jinku.com/org/video/?goods_id=' + goodsId);
                a.setAttribute("target", "_blank");
                a.click();
                document.getElementsByTagName("body")[0].appendChild(a);
                a.remove();
            },
            nextStudy() { // 开始下一阶段课程学习
                var url = this.allLevelUrl[this.levelNum + 1];
                url && this.toAppUrl(url);
            },
            showGoods(event,nodeId, isShow) { // 显示节点商品
                var that = this;
                if (!nodeId) return;
                let self = this;
                http({
                    method: 'POST',
                    url: '/org/structure/get-structure-goods',
                    data: "node_id=" + nodeId
                }).then(function(data) {
                    //var goodsArr = [];
                    if (!data || !data.data || !data.data.length) return;
                    if (!that.firstGoodsId) {
                        that.firstGoodsId = data.data.id;
                    }
                    isShow && bus.$emit('show', data.data)
                });
                var el = event.currentTarget;
                if(isShow==1){
                  var str = el.className.replace("leaf-node","");
                  el.className = str;
                }
            },
        },

        mounted() {
            this.levelNum = this.$attrs && this.$attrs.levelNum || 0;
            this.studyInfo.progress > 0 && this.myMain();
            this.conceal();
            this.userInfo();
            this.nodeInfo();
            
        },
        created(){

        }
    };
</script>

<style scoped>
    @import url("../route-css/bank-lombard.css");
    .Lombard .goBack{
        text-align: center;
    }
    .goBack{
        position: fixed;
        bottom: 1rem;
        left: 0;
        right: 0;
        width: 2rem;
        height: .6rem;
        margin: auto;
        color: #FFFFFF;
        font-size: .32rem;
        line-height: .6rem;
        background: #0791FB;
        border-radius: .2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/route/bank-lombard.vue